// Import model
import { DataviewSettingsResponse } from '../models/DataviewSettingsResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterSettingsRequest } from '../models/FilterSettingsRequest';
import { Settings } from '../models/Settings';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterSettingsRequestSerializer } from './FilterSettingsRequestSerializer';
import { SettingsSerializer } from './SettingsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewSettingsResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewSettingsResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewSettingsResponse instance
   */
  static deserialize(json: string): DataviewSettingsResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewSettingsResponse instance
   */
  static fromObject(obj: any): DataviewSettingsResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewSettingsResponse');
    }


    const instance: DataviewSettingsResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        SettingsSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterSettingsRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewSettingsResponse instances
   */
  static deserializeArray(json: string): DataviewSettingsResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewSettingsResponse instance to a JSON string
   */
  static serialize(instance: DataviewSettingsResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewSettingsResponse instance to a plain object
   */
  static toObject(instance: DataviewSettingsResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        SettingsSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterSettingsRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewSettingsResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewSettingsResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
